(function() {
    'use strict';
    var controllerId = 'usersCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$cookies', '$location', 'ngTableParams',  usersCtrl]);

    function usersCtrl(common, datacontext, $scope, $modal, $cookies, $location, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        var host = $location.host();

        vm.users = [];
        vm.user = [];
        vm.userRoles = [];
        vm.title = 'Users Detail';

        vm.title = 'Users';

        vm.query = {
            queryType:'array-count',
            active_user: 1
        };

        activate();

        function activate() {
            var promises = [get_user_by_id(), get_users(),get_user_role()];
            common.activateController(promises, controllerId)
                .then(function () {  });
        }

        $scope.get_users = function(active_user) {
            vm.query = {
                active_user: active_user,
                order_by:"user_login",
                order_dir:"desc",
                is_empty:1,
                page:1,
                limit:50
            }

            return datacontext.get_users(vm.query).then(function (httpResult) {
                //params.total(httpResult.data.TOTAL);
                vm.results_total = httpResult.data.TOTAL;
                vm.results = httpResult.data.data;
                return httpResult.data.data;
            });
        }

        function get_users() {
        	 console.log("run product");

             console.log("cookie",$cookies.get('user_id'));
             vm.query = {
                     order_by:"user_login",
                     order_dir:"desc",
                     active_user: 1,
                     is_empty:1,
                     page:1,
                     limit:50
                 };
             vm.tableParams = new ngTableParams({
                 count: vm.query.limit // count per page
             }, {
                 getData: function(params) {

                     vm.query.page = params.page;
                     //vm.query.count = params.count;

                     for(var key in params.sorting()) {
                         vm.query.order_by = key;
                         vm.query.order_dir = params.sorting()[key];
                     }
                     // ajax request to api

                     //console.log(vm.query);
                 	return datacontext.get_users(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                 		vm.results_total = httpResult.data.TOTAL;
                 		vm.results = httpResult.data.data;
                 		return httpResult.data.data;
                    });
                 }
             });


        }

        function get_user_by_id() {
            var uid = $cookies.get('user_id');
            datacontext.get_users({user_id: uid,from_user_list:1}).then(function(httpResult) {
                vm.userData = httpResult.data.data[0];
            });
        }

        function get_user_role() {
            datacontext.get_user_role().then(function(httpResult) {
                vm.userRoles = httpResult.data.data;
            });
        }

        $scope.UserModal = function (type,item) {

            $scope.data = {
                type: type,
                userRoles: vm.userRoles,
                user: item
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/users/partials/user_detail.html',
                controller: 'userEditModalCtrl',
                resolve: {
                    data: function () {
                        return $scope.data;
                    }
                }
            }).result.then(function (result) {
                get_users();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();


(function() {
    'use strict';
    var controllerId = 'userEditModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'data', userEditModalCtrl]);

    function userEditModalCtrl(common, datacontext, $scope, $modalInstance, data) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;

        $scope.data = data;

        if(data.user !== undefined){
            $scope.type = "Edit";
        }else{
            $scope.type = "Add";
        }

        $scope.update = function() {
            datacontext.update_user(data.user).then(function(httpResult) {
                log_success("Updated");
                $modalInstance.close();
            });
        }

        $scope.add = function() {
            console.log("add",data.user);
            datacontext.ins_user(data.user).then(function(httpResult) {
                log_success("Added User");
                $modalInstance.close();
            });
        }

        /*$scope.add = function() {
            console.log("add",data.user);
            console.log("add",data.user.user_password);
            
            if (data.user.user_password === undefined) {
                $scope.passwordError = "Password is required.";
            }else{
                var passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{12,}$/;
                if (!passwordRegex.test(data.user.user_password)) {
                    $scope.passwordError = "Password must contain at least one lowercase letter, one uppercase letter, one number, one special character, and be at least 12 characters long";
                } else {
                    $scope.passwordError = null;
                    datacontext.ins_user(data.user).then(function(httpResult) {
                        console.log(httpResult.data);

                        if(httpResult.data.success === true){
                            log_success("Added User");
                            $modalInstance.close();
                        }else{
                            log_error(httpResult.data.ERROR_MSG);
                        }
                    });
                }
            }
        }*/

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();


(function () {
    'use strict';
    var controllerId = 'loginCtrl';
    angular.module('app').controller(controllerId, ['common','userService', 'authenticationService', '$scope', '$modal', '$location', '$window', '$cookies', adminUserCtrl]);

    function adminUserCtrl(common, userService, authenticationService, $scope, $modal, $location, $window, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId,'error');
        var vm = this;

        vm.login = {user_name:'', password:''};

        $scope.logIn = function logIn() {

            if (vm.login.user_name !== undefined && vm.login.password !== undefined) {

                userService.logIn(vm.login).success(function (httpResult) {
                    if (httpResult.success && httpResult.success !== 'fail') {
                        authenticationService.isLogged = true;
                        if(httpResult.data.user_id === 27){
                          var d = new Date();
                          var d3 = d.getMinutes();
                          var expireDate = d.setMinutes(d.getMinutes() + 25);
                          var expireDate = new Date();
                          expireDate.setDate(expireDate.getDate() + 1);
                          var expireDate1 = new Date();
                          expireDate1.setMinutes(expireDate1.getMinutes() + 10);
                          $cookies.put('token', httpResult.data.token, {'expires' : expireDate1});
                          $cookies.put('user_id', httpResult.data.user_id, {'expires' : expireDate1});
                          $cookies.put('user_name', httpResult.data.user_name, {'expires' : expireDate1});
                          $cookies.put('user_name', httpResult.data.user_name, {'expires' : expireDate1});
                          $cookies.put('display_name', httpResult.data.display_name, {'expires' : expireDate1});
                          $cookies.put('user_role_id', httpResult.data.user_role_id, {'expires' : expireDate1});
                          console.log("expireDate"+expireDate);
                          console.log("expireDate1"+expireDate1);
                          $cookies.put('token', httpResult.data.token);
                          $cookies.put('user_id', httpResult.data.user_id);
                          $cookies.put('user_name', httpResult.data.user_name);
                          $cookies.put('user_name', httpResult.data.user_name);
                          $cookies.put('display_name', httpResult.data.display_name);
                          $cookies.put('user_role_id', httpResult.data.user_role_id);
                          if(httpResult.USER_LOGIN > 1){
                            var modalInstance = $modal.open({
                                  scope:$scope,
                                  template: "<div><b>NOTICE: You are currently logged into more than 1 computer</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                                  controller: function(){
                                      $scope.cancel = function(){
                                        modalInstance.dismiss('cancel');
                                      };
                                  }
                              });
                          }

                        }else{
                          $cookies.put('token', httpResult.data.token);
                          $cookies.put('user_id', httpResult.data.user_id);
                          $cookies.put('user_name', httpResult.data.user_name);
                          $cookies.put('user_name', httpResult.data.user_name);
                          $cookies.put('display_name', httpResult.data.display_name);
                          $cookies.put('user_role_id', httpResult.data.user_role_id);
                          if(httpResult.USER_LOGIN > 1){
                            var modalInstance = $modal.open({
                                  scope:$scope,
                                  template: "<div><b>NOTICE: You are currently logged into more than 1 computer</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                                  controller: function(){
                                      $scope.cancel = function(){
                                        modalInstance.dismiss('cancel');
                                      };
                                  }
                              });
                          }
                        }

                        // userService.setCurrentUser(httpResult.data);
                        // console.log($cookies.get('loginReturnURL'));
                        // var loginReturnURL_v1 = $cookies.get('loginReturnURL');
                        // if( angular.isDefined($cookies.get('loginReturnURL')) ){
                        //   $location.path($cookies.get('loginReturnURL'));
                        // }else{
                        //   $location.path('/pickpack/dashboard');
                        // }

                        var loginReturnURL_v1 = decodeURIComponent($cookies.get('loginReturnURL') || '');
                        console.log(loginReturnURL_v1);

                        if (loginReturnURL_v1 && loginReturnURL_v1.includes('.cfm')) {
                            window.location.href = loginReturnURL_v1;
                        }else if (loginReturnURL_v1 && loginReturnURL_v1.startsWith('/#/')){
                            $location.path(loginReturnURL_v1.replace('/#', ''));
                        } else if( angular.isDefined($cookies.get('loginReturnURL')) ){
                            $location.path($cookies.get('loginReturnURL'));
                        }else{    
                            $location.path('/pickpack/dashboard');
                        }

                    }else{
                      authenticationService.isLogged = false;

                      $cookies.remove("token");
                      $cookies.remove("user_id");
                      $cookies.remove("loginReturnURL");
                      $cookies.remove("pickpack_user_status");

                        $location.path('/#/');
                        log('incorrect login / password');
                    }
                }).error(function(status, data) {
                    console.log(status);
                    console.log(data);
                    log('error login / password');
                });
            }
        };

        $scope.logout = function logout() {
            if (authenticationService.isLogged) {
                authenticationService.isLogged = false;

                $cookies.remove("token");
                $cookies.remove("user_id");
                $cookies.remove("loginReturnURL");
                $cookies.remove("pickpack_user_status");

                $location.path('/login');
            }
        }
    }
})();


(function() {
    'use strict';
    var controllerId = 'addressModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','address', addressModalCtrl]);

    function addressModalCtrl(common, datacontext, $scope, $modalInstance, address) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.address = address;

        // Ship Methods
        datacontext.get_address().then(function(response) {
            $scope.ship_methods = response.data.data;
        });

        $scope.ok = function () {
            // set variables
            var formData = {};
            formData.order_id = $scope.fulfillment_order.order_id;
            formData.ship_method_id = $scope.fulfillment_order.ship_method_id;
            formData.tracking_code = $scope.fulfillment_order.tracking_code;

            // create new order ship tracking entry
            return datacontext.createOrderPackage(formData).then(function(httpResult) {
                var order_package_id = httpResult.data.data;
                // loop items flag for update
                var audit_data = {ship_method_id:$scope.fulfillment_order.ship_method_id,tracking_code:$scope.fulfillment_order.tracking_code}
                var audit_info = {audit_subtype_id:10,link_id:$scope.fulfillment_order.order_id,data:audit_data};

                datacontext.create_audit_log(audit_info).then(function(response) {
                    // Refresh Order item data
                });
                $modalInstance.close(order_package_id);
            });


            // add new order ship tracking entry to order item

            $modalInstance.close($scope.fulfill);
            //return datacontext.update_order_status(order[0].order_id, 2).then(function(httpResult) {
            //    $modalInstance.close($scope.fulfillment_order);
            //});
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
(function () {
    'use strict';
    var controllerId = 'messageListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location','$modal', '$cookies','NgTableParams', messageListCtrl]);
    function messageListCtrl(common, datacontext, $scope, $location, $modal, $cookies, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.user_name = $cookies.get('user_name');
        vm.user_id = $cookies.get('user_id');
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            user_id:vm.user_id,
            user_name:vm.user_name,
            order_by:'',
            order_dir:'desc',
            page:1,
            limit:30
        };

        activate();

        function activate() {
            var promises = [
                get_message()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_message() {
            return datacontext.get_message(vm.query).then(function(httpResult) {
                vm.results = httpResult.data.data;
            });
        }

        $scope.readMessage = function (user_login,message,subject,sent_on,message_id,read_on) {

            $scope.read_message = {user_login:user_login,
                                  message:message,
                                  subject:subject,
                                  sent_on:sent_on,
                                  message_id:message_id,
                                  read_on:read_on
                                };
            if(read_on === 0){
              datacontext.read_message(message_id).then(function (httpResult) {
              });
              if($scope.user_id !== 'undefined'){
                datacontext.get_message_cnt($scope.user_id).success(function(httpResult) {
                  $scope.message_cnt = httpResult.TOTAL;
                });
              }
            }
            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/messages/read_message.html',
                controller:"readMessageCtrl",
                windowClass:'small',
                resolve: {
                    read_message: function () {
                        return $scope.read_message;
                    }
                }
            }).result.then(function(){
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.sendMessageModal = function () {

            $scope.send_message = {user:""};

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/messages/send_message.html',
                controller:"sendMessageModalCtrl",
                windowClass:'small',
                resolve: {
                    send_message: function () {
                        return $scope.send_message;
                    }
                }
            }).result.then(function(){
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'readMessageCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', '$window', 'read_message', readMessageCtrl]);

    function readMessageCtrl(common, datacontext, $scope, $modalInstance, $window, read_message) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        console.log(read_message);
        $scope.read_message = read_message;
  }
})();

(function() {
    'use strict';
    var controllerId = 'sendMessageModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', '$window', 'send_message', sendMessageModalCtrl]);

    function sendMessageModalCtrl(common, datacontext, $scope, $modalInstance, $window, send_message) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        activate();
        var vm = this;
        function activate() {
            var promises = [
                get_users_mes()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_users_mes() {
            return datacontext.get_users_mes().then(function(httpResult) {
                $scope.users = httpResult.data.data;
                console.log($scope.users);
            });
        }
        // Pushes input to scope
        $scope.submitted = 0;

$scope.send_message = function(message_details) {
    $scope.submitted = 1;
    console.log(message_details);


            datacontext.send_message(message_details).then(function (httpResult) {
                //$scope.pickpack_slip.pickpack_type_id = httpResult.data;
                $scope.isCreated = true;

                // close it
                $modalInstance.close();
            });
};
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'customersCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies', '$modal', '$location','$routeParams','NgTableParams', customersCtrl]);

    function customersCtrl(common, datacontext, $scope, $cookies, $modal, $location, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

         activate();

        function activate() {
            var promises = [get_customers()];
            common.activateController(promises, controllerId)
                .then(function () {  });
        }

        function get_customers(){
            vm.query = {
                order_by: "customer_id"
                , order_dir: "desc"
                , page: 1
                , limit: 50
            };

            vm.tableParams = new NgTableParams({
                count: vm.query.limit
            }, {
                getData: function(params) {
                    vm.query.page = params.page;

                    for (var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    return datacontext.get_customers(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        vm.customerResults = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.edit_customer = function(customer_id, first_name, last_name, email) {

            $scope.customer_values = {
                customer_id:customer_id, 
                first_name:first_name, 
                last_name:last_name, 
                email:email
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/users/partials/edit_customer.html',
                controller:"cstEditModalCtrl",
                resolve: {
                    customer_values: function () {
                        return $scope.customer_values;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_customers();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'cstEditModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies', '$modal', '$modalInstance', 'customer_values', cstEditModalCtrl]);

    function cstEditModalCtrl(common, datacontext, $scope, $cookies, $modal, $modalInstance, customer_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope
        $scope.customer_values = customer_values;
        console.log(customer_values);

        $scope.ok = function (customer_id, first_name, last_name, email) {

            var payload = {
                customer_id: customer_id,
                first_name: first_name, 
                last_name: last_name, 
                email: email
            };

            return datacontext.edit_customer(payload).then(function (httpResult) {
                console.log(httpResult.data);
                if(httpResult.data === "false"){
                    $scope.error_message = "Product Source already exists!";
                } else{
                    $modalInstance.close();
                }
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        }
    };
})();
